var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import { Select } from "@irati/ui/src/FormItem";
import Validation from "@irati/utils/validation";
import id from "@irati/utils/id";
import withRewardOnChange from "./withRewardOnChange";
var PROPERTY = "isCredit";
var options = [
    {
        value: true,
        label: "Yes"
    },
    {
        value: false,
        label: "No"
    }
];
function mapYesOrNo(value) {
    if (value)
        return "Yes";
    return "No";
}
var IsCredit = /** @class */ (function (_super) {
    __extends(IsCredit, _super);
    function IsCredit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (value) {
            var _a = _this.props, reward = _a.reward, onChange = _a.onChange;
            onChange(reward, PROPERTY, value);
        };
        return _this;
    }
    IsCredit.prototype.render = function () {
        var _a = this.props, reward = _a.reward, required = _a.required, label = _a.label, onChange = _a.onChange, otherProps = __rest(_a, ["reward", "required", "label", "onChange"]);
        if (reward.uuid) {
            return React.createElement("div", null,
                "Is this reward credit: ", "" + mapYesOrNo(reward.isCredit));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Select, __assign({ name: PROPERTY, value: reward.isCredit, options: options, onChange: this.handleChange, label: "" + label + (required ? "*" : ""), validation: Validation.string("Please select if the reward is credit") }, otherProps, { id: id(PROPERTY, otherProps) })),
            React.createElement("small", { className: "text-helper" }, "You can't change the credit status after selecting")));
    };
    IsCredit.defaultProps = {
        label: "Is the reward credit? :",
        required: true,
        reward: null
    };
    return IsCredit;
}(Component));
export { IsCredit };
export default withRewardOnChange(IsCredit);
